var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#4FC098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.429 16.969H21.143V18.819C21.678 17.755 23.05 16.799 25.111 16.799C29.062 16.799 30 18.917 30 22.803V30H26V23.688C26 21.475 25.465 20.227 24.103 20.227C22.214 20.227 21.429 21.572 21.429 23.687V30H17.429V16.969ZM10.57 29.83H14.57V16.799H10.57V29.83ZM15.143 12.55C15.1431 12.8853 15.0767 13.2172 14.9474 13.5266C14.8181 13.8359 14.6287 14.1165 14.39 14.352C13.9064 14.8326 13.2518 15.1017 12.57 15.1C11.8894 15.0995 11.2363 14.8312 10.752 14.353C10.5142 14.1167 10.3254 13.8358 10.1963 13.5264C10.0673 13.217 10.0006 12.8852 10 12.55C10 11.873 10.27 11.225 10.753 10.747C11.2369 10.2682 11.8902 9.9997 12.571 10C13.253 10 13.907 10.269 14.39 10.747C14.872 11.225 15.143 11.873 15.143 12.55Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e640db167bc90c4a55c9fd1687f92cea.svg";
export { ForwardRef as ReactComponent };